import { render, staticRenderFns } from "./SaleOffersAnnouncements.vue?vue&type=template&id=1326d4b8&"
import script from "./SaleOffersAnnouncements.vue?vue&type=script&lang=js&"
export * from "./SaleOffersAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports